module.exports = __webpack_public_path__ + "media/images/recruit/common/icon-x-d8020be367d98edf3ed992c72e6f788d.svg";